import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-external-links',
  templateUrl: './external-links.component.html',
  styleUrls: ['./external-links.component.scss'],
  imports: [TranslateModule]
})
export class ExternalLinksComponent {
  label = input('');
  placeholder = input('https://drive.google.com/...');
  required = input(false);
  submitted = input(false);

  links: string[] = [''];

  linksChange = output<string[]>();

  addLink(): void {
    this.links.push('');
    this.emitLinks();
  }

  removeLink(index: number): void {
    if (this.links.length > 1) {
      this.links.splice(index, 1);
    } else {
      this.links[0] = '';
    }
    this.emitLinks();
  }

  onLinkChange(index: number, value: string): void {
    this.links[index] = value;
    this.emitLinks();
  }

  getValidLinks(): string[] {
    return this.links.filter(link => link.trim() !== '');
  }

  hasValidLinks(): boolean {
    return this.getValidLinks().length > 0;
  }

  isValidUrl(url: string): boolean {
    if (!url || url.trim() === '') return true;
    const trimmed = url.trim();
    return /^https?:\/\/[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?)+/.test(trimmed);
  }

  hasInvalidUrls(): boolean {
    return this.links.some(link => link.trim() !== '' && !this.isValidUrl(link));
  }

  reset(): void {
    this.links = [''];
    this.emitLinks();
  }

  private emitLinks(): void {
    this.linksChange.emit(this.getValidLinks());
  }
}
